import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import { defaultRegistry } from "react-sweet-state";
import { getUserData } from "./api/UserDataLoader";
import { getAppSettings } from "api/api";
import HttpApi from "i18next-http-backend";
import { ListPageStore } from "./store/ListPageStore";

const defaultLanguage = "en-GB";

export const applicationCodeId = 900000000010214;
export const appSettingUserSettingsCodeId = "900000000010304";

// creating a language detection plugin
// http://i18next.com/docs/ownplugin/#languagedetector
const languageDetector = {
  type: "languageDetector" as any, // Exact type is 'backend' | 'logger' | 'languageDetector' | 'postProcessor' | 'i18nFormat' | '3rdParty'
  async: true, // flags below detection to be async
  detect: (callback: Function) =>
    getAppSettings(applicationCodeId)
      .then((userSettings) => {
        defaultRegistry
          .getStore(ListPageStore)
          .actions.seedSettings(applicationCodeId, userSettings.data);
        const userSettingsForViewOptions: any[] = userSettings.data.filter(
          (item: any) =>
            `${item.appSettingCodeId}` === appSettingUserSettingsCodeId,
        );
        if (userSettingsForViewOptions.length) {
          callback(
            userSettingsForViewOptions.find(
              (userSetting: any) => userSetting.isDefault,
            )?.userAppSettingValue || defaultLanguage,
          );
        } else {
          getUserData()
            .then((userData) =>
              callback(userData.preferredLanguage || defaultLanguage),
            )
            .catch(() => callback(defaultLanguage));
        }
      })
      .catch(() =>
        getUserData()
          .then((userData) =>
            callback(userData.preferredLanguage || defaultLanguage),
          )
          .catch(() => callback(defaultLanguage)),
      ),
  init: () => {},
  cacheUserLanguage: () => {},
};

i18n
  .use(HttpApi)
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    load: "currentOnly",
    backend: {
      loadPath: "/locales/{{lng}}.json",
    },
    fallbackLng: (code) => {
      if (!code || code === "en-US") return ["en-GB", "de-AT"];

      if (code === "de-DE") return ["de-AT", "en-GB"];
      if (code === "de-CH") return ["de-AT", "en-GB"];
      if (code === "de-AT") return ["de-AT", "en-GB"];

      return ["en-GB", "de-AT"];
    },
    missingKeyHandler: (lngs, ns, key, fallbackValue) => {
      // Check if the key is available in 'en-GB', and if so, return its value

      if (lngs[1] === "en-GB") {
        return i18n.t(key, { lng: "en-GB" });
      }

      // If not found in 'en-GB', return the fallback value
      // console.warn(`Missing translation key: ${key}`);
      return fallbackValue;
    },
    saveMissing: true,
    supportedLngs: [
      "en-GB",
      "de-AT",
      "bg-BG",
      "cs-CZ",
      "et-EE",
      "hr-HR",
      "hu-HU",
      "lt-LT",
      "pl-PL",
      "ro-RO",
      "ru-RU",
      "sr-Latn-RS",
      "sk-SK",
      "sl-SI",
      "tr-TR",
      "uk-UA",
    ],
    postProcess: ["phraseInContextEditor"],
  });

export default i18n;
